import { useDispatch } from "react-redux";

import InputText from "@/design/forms/InputText";
import { showSnackbar } from "@/store/reducers/app";
import Valkyrie, { viCopy } from "@sippy-platform/valkyrie";

import { IconButton, InputAdornment } from "@mui/material";
import PropTypes from "prop-types";

export default function InputCopy({ id, value, ...props }) {
  const dispatch = useDispatch();

  const copyUrlToClipboard = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        dispatch(showSnackbar("Content copied to clipboard."));
      })
      .catch(() => {
        dispatch(showSnackbar("Could not copy content to the clipboard."));
      });
  };

  return (
    <InputText
      {...props}
      value={value}
      id={id}
      type="text"
      slotProps={{
        input: {
          sx: { pr: 0.25 },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={copyUrlToClipboard} id={`copy-${id}`} aria-label="Copy content">
                <Valkyrie icon={viCopy} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}

InputCopy.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string,
};
